document.addEventListener('DOMContentLoaded', function() {     
    // default expand Searchanise side bar filter 
    function openFilters() {
      // Expand all collapsed filter groups
      document.querySelectorAll('.snize-filters-sidebar .snize-product-filters-block').forEach(function(filter) {
        //filter.classList.remove('snize-collapsed');
        var title = filter.querySelector('.snize-product-filters-title');
        if(title){
          title.classList.add("open");
          title.setAttribute("aria-expanded", true);

        }
        var content = filter.querySelector('.snize-product-filters-list');
        if (content) {
          content.style.display = 'block';
        }
      });
    }

    // Run when Searchanise loads
    document.addEventListener('snize:filters_rendered', function () {
      openFilters();
    });

    // Fallback (in case event doesn't fire)
    setTimeout(openFilters, 1500);
    // end expanding Searchanise side bar filter 

  });